import { render } from "./tegsoftNavbar.vue?vue&type=template&id=ebf9b726&scoped=true"
import script from "./tegsoftNavbar.vue?vue&type=script&lang=js"
export * from "./tegsoftNavbar.vue?vue&type=script&lang=js"

import "./tegsoftNavbar.vue?vue&type=style&index=0&id=ebf9b726&lang=scss&scoped=true"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf9b726"]])

export default __exports__